function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M5.813,0A1,1,0,0,0,5,1V45a1,1,0,0,0,1,1H9v3a1,1,0,0,0,1,1H44a1,1,0,0,0,1-1V5a1,1,0,0,0-1-1H41V1a1,1,0,0,0-1-1H5.813ZM7,2H39V44H7ZM41,6h2V48H11V46H40a1,1,0,0,0,1-1ZM23.188,10.5A6.384,6.384,0,0,0,16.5,16.188c0,.2.113.406.313.406L19.094,17c.2,0,.406-.113.406-.312.4-2.2,1.688-3.375,3.688-3.375a3.191,3.191,0,0,1,3.5,3.281c0,1.3-.387,2.113-1.687,3.813l-2.406,3.281A4.509,4.509,0,0,0,21.5,26.906v1.5a.464.464,0,0,0,.313.406h2.375a.376.376,0,0,0,.406-.406V27.313a3.9,3.9,0,0,1,.906-2.719l2.406-3.281a7.74,7.74,0,0,0,1.781-4.719C29.688,12.992,27.086,10.5,23.188,10.5Zm-1.375,21a.376.376,0,0,0-.406.406V35a.376.376,0,0,0,.406.406H24.5A.376.376,0,0,0,24.906,35V31.906A.376.376,0,0,0,24.5,31.5Z",
  transform: "translate(-5)"
}));

function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default ForwardRef;